import { I18nContext } from 'contexts/I18n/I18nProvider'
import authService from 'core/auth/auth-service'
import { CloseModalFunction, OpenModalFunction } from 'core/modal/redux/types'
import { useCallback, useContext, useEffect } from 'react'
import { Link } from 'react-router-dom'
import OnnetOffnetGridComponent from './OnnetOffnetGridComponent'
import './index.scss'
import { getRangeEntries } from './redux/action'
import useOnnetOffnet from './redux/hooks'
import { IPGroup, OnnetOffnetResult, OnnetOffnetRow } from './redux/reducer'

type OnnetOffnetComponentProps = {
  ranges: Array<OnnetOffnetRow>
  rangesIpv6: Array<OnnetOffnetRow>

  execute:  () => Promise<any>
  submitChanges: (result: OnnetOffnetResult) => Promise<void>

  openModal: OpenModalFunction
  closeModal: CloseModalFunction
}

export default function OnnetOffnetComponent({ 
  execute,
  submitChanges,
  openModal,
  closeModal,
  ranges,
  rangesIpv6,
}: OnnetOffnetComponentProps) {
  const {
    ipv4,
    setIpv4,
    ipv6,
    setIpv6,
    selectEntry,
    saveEntry,
    saveNewEntry,
    removeEntry,
  } = useOnnetOffnet()

  const t = useContext(I18nContext)

  useEffect(() => {
    execute()
  }, [])

  useEffect(() => {
    setIpv4(ranges)
    setIpv6(rangesIpv6)
  }, [ranges, rangesIpv6])

  const handleSubmit = () => {
    submitChanges({ opco: authService.getCurrentOpco(), ranges: ipv4, rangesIpv6: ipv6  })
  }

  const hasChanges = useCallback(() => {   
    return getRangeEntries(ipv4).length || getRangeEntries(ipv6).length
  }, [ipv4, ipv6])

  return (
    <div className="section">
      <nav className="level">
        <div className="level-left">
          <h3 className="subtitle is-5" style={{ display: 'inline', marginRight: '10px' }}>
            Onnet Offnet
            <p>
              <Link
                style={{ fontSize: '13px', color: 'grey' }}
                className="is-small"
                to={{ pathname: `/` }}
                state={{ title: 'Home' }}
              >
                <span className="icon">
                  <i className="mdi mdi-keyboard-return" />
                </span>
                {t('general.link_back')}
              </Link>
            </p>
          </h3>
        </div>
        <div className="level-right is-2">
          <button className="button is-primary button-content" onClick={() => handleSubmit()} disabled={!hasChanges()}>
            <span className="icon">
              <i className="mdi mdi-playlist-check" />
            </span>
            <span>{t('onnet_offnet.label_submit_changes')}</span>
          </button>
        </div>
      </nav>
      <div className="table-container">
        <div className="table-item">
          <OnnetOffnetGridComponent
            group={IPGroup.v4}
            ipRange={ipv4}
            selectEntry={selectEntry}
            removeEntry={removeEntry}
            saveEntry={saveEntry}
            openModal={openModal}
            closeModal={closeModal}
            saveNewEntry={saveNewEntry}
          />
        </div>
        <div className="table-item">
          <OnnetOffnetGridComponent
            group={IPGroup.v6}
            ipRange={ipv6}
            selectEntry={selectEntry}
            removeEntry={removeEntry}
            saveEntry={saveEntry}
            openModal={openModal}
            closeModal={closeModal}
            saveNewEntry={saveNewEntry}
          />
        </div>
      </div>
    </div>
  )
}
